import React from 'react';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';
import { SectionHeader } from './shared/SectionHeader';
import { formatCurrencyCompact, formatStat } from '../utils/formatters';

const SOURCE_COLORS = {
  'google': '#4285F4',
  'meta': '#1877F2',
  'instagram': '#E4405F',
  'facebook': '#1877F2',
  'bing': '#008373',
  'direct': '#10B981',
  'email': '#F59E0B',
  'referral': '#EC4899',
};

export function TrafficOverview({ trafficSourcesAnalytics, isMarketer }) {
  if (isMarketer) return null;

  const data = trafficSourcesAnalytics?.tableData || [];
  const totals = trafficSourcesAnalytics?.totals || {};
  const maxSessions = Math.max(...data.map(d => d.sessions || 0), 1);
  const top10 = data.slice(0, 10);

  if (top10.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5 }}
      className="mb-6"
    >
      <SectionHeader title="Traffic Sources" icon={Globe} subtitle={`${formatStat(totals.sessions || 0)} total sessions`} />
      <div className="glass-card rounded-2xl overflow-hidden">
        <table className="modern-table">
          <thead>
            <tr>
              <th className="text-left pl-5">Source / Medium</th>
              <th className="text-right">Sessions</th>
              <th className="text-left pl-4" style={{ width: '30%' }}></th>
              <th className="text-right">Conv. Rate</th>
              <th className="text-right pr-5">Revenue</th>
            </tr>
          </thead>
          <tbody>
            {top10.map((row, i) => {
              const barPct = maxSessions > 0 ? (row.sessions / maxSessions) * 100 : 0;
              const sourceColor = SOURCE_COLORS[row.source?.toLowerCase()] || '#6B7280';
              return (
                <tr key={i}>
                  <td className="pl-5">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full shrink-0" style={{ background: sourceColor }} />
                      <span className="text-xs font-medium text-gray-800">{row.source}</span>
                      <span className="text-[10px] text-gray-400">/ {row.medium}</span>
                    </div>
                  </td>
                  <td className="text-right text-xs font-semibold text-gray-800">{formatStat(row.sessions)}</td>
                  <td className="pl-4">
                    <div className="h-[3px] rounded-full bg-gray-100 overflow-hidden">
                      <div
                        className="h-full rounded-full transition-all duration-500"
                        style={{ width: `${barPct}%`, background: sourceColor }}
                      />
                    </div>
                  </td>
                  <td className="text-right text-xs text-gray-600">{(row.conversionRate || 0).toFixed(2)}%</td>
                  <td className="text-right pr-5 text-xs font-semibold text-gray-800">{formatCurrencyCompact(row.revenue)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
}
